import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface GenerateTemplateRequest {
  session_id: string;
}

interface GenerateTemplateResponse {
  status: string;
  error: string | null;
  result: {
    query: string;
    extra_instructions: string;
  } | null;
}

const generateAnalysisTemplate = async (
  data: GenerateTemplateRequest
): Promise<GenerateTemplateResponse> => {
  const response = await instance.post('/nexa/analysis-templates/generate', data);
  return response.data;
};

export const useGenerateAnalysisTemplate = () => {
  return useMutation({
    mutationFn: generateAnalysisTemplate,
    onSuccess: (data) => {
      if (data.status === 'success') {
        message.success('Analysis template generated successfully');
      } else {
        message.error(data.error || 'Failed to generate analysis template');
      }
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.error?.message || 'Failed to generate analysis template');
    },
  });
};
